jPar.wdk = jPar.wdk || {};
$j.extend(true, jPar.wdk, {
	/**
	 * @deprecated use wdk-dialog instead
	 */
	modalbox: {
		conf: {},

		show: function (param) {
			const _this = this;

			jPar.wdk.modalbox.hide(true);
			document.querySelector('wdk-dialog[open]')?.closeModal(true);
			this.modalboxAbortController = new AbortController();
			this.setConfig(param);

			// console.log('isAjaxModalbox: ' + this.conf.isAjaxModalbox);
			if (this.conf.isAjaxModalbox) {
				_this.loadAjax();
			} else {
				_this.loadInline();
			}
			document.dispatchEvent(new CustomEvent('wdkModalBox:shown'));
		},

		setConfig: function (param) {
			// TODO split in 2 Methoden?
			this.conf = {
				// set Initial State for every Modalbox
				$currentModalbox: null, // jQuery Obj
				jqxhr: null, // jQuery XHR Objekt
				isAjaxModalbox: false, // wenn ein data-url vorhanden ist, wird das true
				url: null,
				ajaxSettings: null, // hier kan das Ajax-Objekt aufgebohrt werden (z.B. nimm POST mit folgenden Parametern, X-Header usw.)
				closeOnBgClick: false, // bei true kann auf background klick geschlossen werden
				closeOnEsc: false, // bei true kann mit ESC geschlossen werden
				originalPageScrollPosition: null, // Damit wir beim schließen wieder zurückscrollen können
				previousActiveElement: null, // a11y bei close wieder focussieren
				onSuccess: null,
				onFail: null,
				onAlways: null, // Callback wird in jedem Fall aufgerufen
				onBeforeClose: null,
			};

			// TODO umstellen, das immer der komplette slektor mitgegebn werden muss
			let modalboxSelector = $j(param.modalboxId);
			if (param.modalboxId.indexOf('#') === -1) {
				modalboxSelector = $j('#' + param.modalboxId);
			}

			const $currentModalbox = modalboxSelector;
			if ($currentModalbox.length > 0) {
				this.conf.$currentModalbox = $currentModalbox;

				if (typeof $currentModalbox.data('url') !== 'undefined') {
					this.conf.isAjaxModalbox = true;
					this.conf.url = $currentModalbox.data('url');

					const hasAjaxSettings = typeof param.ajaxSettings !== 'undefined';
					if (hasAjaxSettings) {
						this.conf.ajaxSettings = param.ajaxSettings;
					}

					const hasFailCallback = typeof param.onFail !== 'undefined';
					if (hasFailCallback) {
						this.conf.onFail = param.onFail;
					}

					const hasAlwaysCallback = typeof param.onAlways !== 'undefined';
					if (hasAlwaysCallback) {
						this.conf.onAlways = param.onAlways;
					}
				}

				const hasCloseOnBgClickAttr = typeof $currentModalbox.data('closeOnBgClick') !== 'undefined';
				if (hasCloseOnBgClickAttr) {
					this.conf.closeOnBgClick = $currentModalbox.data('closeOnBgClick');
				}

				const hasCloseOnEscAttr = typeof $currentModalbox.data('closeOnEsc') !== 'undefined';
				if (hasCloseOnEscAttr) {
					this.conf.closeOnEsc = $currentModalbox.data('closeOnEsc');
				}

				this.conf.originalPageScrollPosition = $j(document).scrollTop();
				this.conf.previousActiveElement = document.activeElement;

				const hasSuccessCallback = typeof param.onSuccess !== 'undefined';
				if (hasSuccessCallback) {
					this.conf.onSuccess = param.onSuccess;
				}

				const hasBeforeCloseCallback = typeof param.onBeforeClose !== 'undefined';
				if (hasBeforeCloseCallback) {
					this.conf.onBeforeClose = param.onBeforeClose;
				}
			} else {
				jPar.wdk.modalbox.show({ modalboxId: 'errorModalbox500' });
				throw new Error('wdkmodalbox: Modalbox ID not found on Page ' + param.modalboxId);
			}
		},

		loadAjax: function () {
			const _this = this;
			const $currentModalbox = this.conf.$currentModalbox;
			let _ajaxSettings = '';

			if (_this.conf.ajaxSettings !== null) {
				_ajaxSettings = _this.conf.ajaxSettings;
			}

			this.conf.jqxhr = $j
				.ajax(_this.conf.url, _ajaxSettings)
				.done(function (responseText) {
					_this.handleSessionExpired(responseText);

					$currentModalbox.html(responseText);
					_this.setCloseEvents();
					_this.handleSpecialDataConfigs();
					_this.makeVisible();

					if (_this.conf.onSuccess !== null) {
						_this.conf.onSuccess();
					}
				})
				.fail(function (jqXHR, textStatus, errorThrown) {
					if (typeof _this.conf.onFail === 'function') {
						_this.conf.onFail(jqXHR, textStatus, errorThrown);
					}

					_this.handleNetworkErrors(jqXHR, textStatus, errorThrown, $currentModalbox);
				})
				.always(function () {
					if (typeof _this.conf.onAlways === 'function') {
						_this.conf.onAlways();
					}
				});
		},

		loadInline: function () {
			this.setCloseEvents();
			this.makeVisible();

			if (this.conf.onSuccess !== null) {
				this.conf.onSuccess();
			}
		},

		// Bei Ajax Layer können überraschende Ding zurückgeleifert werden. (MessagingNotAllowed) Wenn diese Layer Inhalte eine spezielle Config brauchen, können die per Data-Attribut gesetzt werden.
		handleSpecialDataConfigs: function () {
			if (this.conf.$currentModalbox.find('[data-set-small-content-class=true]').length > 0) {
				this.conf.$currentModalbox.addClass('has-smallContent');
			}

			if (this.conf.$currentModalbox.find('[data-set-full-bg-image-class=true]').length > 0) {
				this.conf.$currentModalbox.addClass('has-fullBgImage');
			}
		},

		makeVisible: function () {
			this.conf.$currentModalbox[0].classList.remove('noDisplay'); // Boxen mit vieeelen DOMKnoten verlangsamen das SeitenRendering merklich. (siehe Payment AGB boxen).
			this.moveModalboxDomToBottom();

			$j('html').addClass('has-modalboxOpen');
			// Js-Hack: layout trashing - apply all pending style changes
			let $currentModalbox;
			if (this.conf.$currentModalbox.hasClass('wdk-modalbox')) {
				$currentModalbox = this.conf.$currentModalbox;

				// Bei den editLayer Modalboxen kommt die Class erst durch das Ajax geladene FTL ins Dom.
				// Die eigentliche Modalbox beginnt also erst eine Ebene tiefer.
			} else if (this.conf.$currentModalbox.find('.wdk-modalbox').length > 0) {
				$currentModalbox = this.conf.$currentModalbox.find('.wdk-modalbox');
			}

			if ($currentModalbox.find('textarea').length > 0) {
				$currentModalbox.addClass('has-textarea');
			}

			$currentModalbox.css('color'); // Der Wrapper verändert die Sichbarkeit von display none auf block, da braucht er das wohl
			$currentModalbox.addClass('is-open transition-in');

			this.setA11yForOpenModal();
			this.setInitialFocus();
			this.hideCloseButtonInApps();
			document.dispatchEvent(new CustomEvent('wdk:modalbox:isOpened', { detail: { $modalboxObj: $currentModalbox } }));
		},

		setA11yForOpenModal: function () {
			// this.conf.$currentModalbox.attr('aria-hidden', 'false');
			// $j('#pageWrapper').attr('aria-hidden', 'true');

			const nodesArray = Array.prototype.slice.call(document.body.children);
			nodesArray.forEach((child) => {
				const currentlyInert = child.getAttribute('inert') !== null;
				if (currentlyInert) {
					child.setAttribute('data-inert-before', true);
				}

				const isNotModalboxDom = child !== this.conf.$currentModalbox[0];
				const isNotBackstageTool = child.getAttribute('id') !== 'backstageOpenerRwd';
				if (isNotModalboxDom && isNotBackstageTool) {
					child.setAttribute('inert', true); // Alle anderen Domknoten blockieren
				} else {
					child.removeAttribute('inert'); // Modal freigeben
				}
			});
		},

		setA11yForClosedModal: function () {
			// this.conf.$currentModalbox.attr('aria-hidden', 'true');
			// $j('#pageWrapper').removeAttr('aria-hidden');

			const nodesArray = Array.prototype.slice.call(document.body.children);
			nodesArray.forEach((child) => {
				const restoreInert = child.getAttribute('data-inert-before') !== null;
				if (restoreInert) {
					child.setAttribute('inert', true);
					child.removeAttribute('data-inert-before');
				} else {
					child.removeAttribute('inert');
				}
			});
		},

		setInitialFocus: function () {
			const _this = this;
			let focusElement = null;
			const hasNoSpecialFocusField = this.conf.$currentModalbox.find('.js-focusField').length === 0;
			const hasNoAriaLabel = this.conf.$currentModalbox.filter('[aria-labelledby]').length === 0;

			if (hasNoSpecialFocusField) {
				if (this.conf.$currentModalbox.find('header h3').length > 0 && this.conf.$currentModalbox.find('header h3').text().trim() !== '') {
					focusElement = 'header h3';
				} else if (this.conf.$currentModalbox.find('h3').length > 0 && this.conf.$currentModalbox.find('h3').text().trim() !== '') {
					focusElement = 'h3';
				} else if (this.conf.$currentModalbox.find('header').length > 0 && this.conf.$currentModalbox.find('header').text().trim() !== '') {
					focusElement = 'header';
				} else if (this.conf.$currentModalbox.find('article').length > 0) {
					focusElement = 'article';
				}

				if (hasNoAriaLabel && focusElement !== null) {
					this.conf.$currentModalbox.one('transitionend', function () {
						_this.conf.$currentModalbox.find(focusElement).attr('tabindex', '0').trigger('focus');
					});
				} else {
					this.conf.$currentModalbox.one('transitionend', function () {
						jPar.util.setFocusOnFirstFocusableElement(_this.conf.$currentModalbox.find('article *'));
					});
				}
			}
		},

		setPreviousFocus: function () {
			const _this = this;

			this.conf.$currentModalbox.one('transitionend', function () {
				_this.conf.previousActiveElement.focus();
			});
		},

		hide: function (fastHide) {
			const $modalboxObj = $j('.wdk-modalbox.is-open');
			if ($modalboxObj.length > 0) {
				const _this = this;

				const isModalInModalOpen = $modalboxObj.find('.layerInModalbox.is-open').length > 0;
				if (isModalInModalOpen) {
					jPar.wdk.modalbox.layerInModalbox.hide();
				} else {
					const isAllowedToClose = this.conf.onBeforeClose === null || this.conf.onBeforeClose() === true;
					if (isAllowedToClose) {
						const $modalboxObj = $j('.wdk-modalbox.is-open');

						$modalboxObj.one('transitionend', function () {
							$j('html').removeClass('has-modalboxOpen');
							// $j('html').removeClass('has-smallContentModalbox');
							_this.moveModalboxDomToOriginalPosition();

							$j('.wdk-modalbox.is-open').removeClass('is-open transition-out');
							_this.removeEventListener();

							window.setTimeout(function () {
								// WTF, ohne das timeout geht das scrollback in S auf der supercard Seite nicht
								window.scrollTo(0, _this.conf.originalPageScrollPosition);
							}, 1);

							document.dispatchEvent(new CustomEvent('wdk:modalbox:isHidden', { detail: { $modalboxObj: $modalboxObj } }));
						});

						$modalboxObj[0].removeAttribute('popover');
						$modalboxObj.removeClass('transition-in').addClass('transition-out');

						this.setA11yForClosedModal();
						this.setPreviousFocus();
						this.showCloseButtonInApps();

						if (fastHide || jPar.wdk.screensize.isBreakpoint(['S', 'M'])) {
							$modalboxObj.trigger('transitionend');
						}
						_this.modalboxAbortController.abort();
					}
				}
			}
		},

		closeCurrentModalbox: function () {
			if ($j('.wdk-modalbox.is-open').length > 0) {
				jPar.wdk.modalbox.hide(true);
			}
		},

		moveModalboxDomToBottom: function () {
			$j('<div class="modalboxPlaceholder"></div>').insertBefore(this.conf.$currentModalbox);
			this.conf.$currentModalbox.detach().appendTo('body'); // Im DOM nach unten schieben
		},

		moveModalboxDomToOriginalPosition: function () {
			if (this.conf.isAjaxModalbox) {
				// reihenfolge wegen removeClass is-open
				$j('.wdk-modalbox.is-open').empty();
				$j('.wdk-modalbox.is-open').remove().insertAfter('.modalboxPlaceholder');
			} else {
				$j('.wdk-modalbox.is-open').insertAfter('.modalboxPlaceholder');
			}

			$j('.modalboxPlaceholder').remove();
		},

		removeEventListener: function () {
			$j(document).off('.modalboxEvent');

			// For iOS
			$j(document).off('touchmove');
			$j('body').off('touchstart', '.scrollable');
			$j('body').off('touchmove', '.scrollable');
		},

		setCloseEvents: function () {
			document.addEventListener(
				'click',
				(event) => {
					const closeSelector = '#' + this.conf.$currentModalbox.attr('id') + ' .js-closeModalbox';
					const closeElems = Array.from(document.querySelectorAll(closeSelector));
					if (closeElems.includes(event.target)) {
						event.preventDefault();
						this.hide();
					}
				},
				{ signal: this.modalboxAbortController.signal },
			);

			this.conf.$currentModalbox[0].querySelector('.js-reloadPage')?.addEventListener(
				'click',
				(event) => {
					event.preventDefault();
					event.stopPropagation();
					event.stopImmediatePropagation();
					document.location.reload();
				},
				{ signal: this.modalboxAbortController.signal },
			);

			if (this.conf.closeOnBgClick === true) {
				document.addEventListener(
					'mousedown',
					(event) => {
						const isClickedOnModalbox =
							event.target.matches('.wdk-modalbox .modalboxContent') || event.target.closest('.wdk-modalbox .modalboxContent');
						if (!isClickedOnModalbox) {
							this.hide();
						}
					},
					{ signal: this.modalboxAbortController.signal },
				);
			}

			if (this.conf.closeOnEsc === true) {
				document.addEventListener(
					'keyup',
					(event) => {
						if (event.key === 'Escape') {
							this.hide();
						}
					},
					{ signal: this.modalboxAbortController.signal },
				);
			}
		},

		// webkit = {messageHandlers : {hideCloseButton :{postMessage: function() { console.log('pooost'); }}}}
		// Android = {hideCloseButton: function() {console.log('cloooooose in android');}
		showCloseButtonInApps: function () {
			// DEV-32164
			if (this.conf.$currentModalbox.hasClass('has-smallContent') === false) {
				// Just the Big Modals should hide the X of the NativeApp
				const hasIosAppWrapper = window.webkit?.messageHandlers?.showCloseButton !== undefined;
				if (hasIosAppWrapper) {
					window.webkit.messageHandlers.showCloseButton.postMessage(true);
				}

				const hasAndroidWrapper = window.Android?.showCloseButton !== undefined; // NOSONAR
				if (hasAndroidWrapper) {
					Android.showCloseButton(); // NOSONAR
				}
			}
		},

		hideCloseButtonInApps: function () {
			// DEV-32164
			if (this.conf.$currentModalbox.hasClass('has-smallContent') === false) {
				// Just the Big Modals should hide the X of the NativeApp
				const hasIosAppWrapper = window.webkit?.messageHandlers?.hideCloseButton !== undefined;
				if (hasIosAppWrapper) {
					window.webkit.messageHandlers.hideCloseButton.postMessage(true);
				}

				const hasAndroidWrapper = window.Android?.hideCloseButton !== undefined; // NOSONAR
				if (hasAndroidWrapper) {
					Android.hideCloseButton(); // NOSONAR
				}
			}
		},

		handleNetworkErrors: function (jqXHR, textStatus, errorThrown, $currentModalbox) {
			this.conf.jqxhr.fail(function () {
				if (textStatus === 'timeout') {
					document.querySelector('wdk-snackbar#timeoutNotification').show();
				} else {
					jPar.wdk.modalbox.show({ modalboxId: 'errorModalbox500' });

					if (jqXHR.status !== 0) {
						jPar.util.log.error(
							$currentModalbox.attr('id') + ' on Page ' + $j('body').attr('id') + ' reported ' + jqXHR.status + ' - ' + errorThrown,
							'Error opening wdkmodalbox',
						);
					}
				}
			});
		},

		handleSessionExpired: function (response) {
			if (jPar.util.network.hasValidSessionAndCsrfToken(response) === false) {
				jPar.util.network.reloadIfResponseInvalid(response);

				throw new Error('wdkmodalbox: Session expired'); // wichtig - sonst wird der ursprüngliche Layer weiter grendert und zeigt die login-seite an
			}
		},

		layerInModalbox: {
			previousActiveElementInModal: null,

			show: function (elemSelector) {
				const _this = this;

				const currentLayerInModal = document.querySelector('.wdk-modalbox.is-open ' + elemSelector);
				if (currentLayerInModal !== null) {
					this.previousActiveElementInModal = document.activeElement;

					currentLayerInModal.classList.add('is-open');
					currentLayerInModal.querySelector('header h3')?.focus();

					$j('.wdk-modalbox.is-open .js-closeLayerInLayer').on('click', function (event) {
						event.preventDefault();
						_this.hide();
					});
				}
			},

			hide: function () {
				const layerInModalbox = document.querySelector('.wdk-modalbox.is-open .layerInModalbox.is-open');
				if (layerInModalbox !== null) {
					layerInModalbox.classList.remove('is-open');
					this.previousActiveElementInModal.focus();
					$j('.wdk-modalbox.is-open .js-closeLayerInLayer').off('click');
				}
			},
		},
	},
});
